
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import Index from './Dashboard/Index';
import Icons from './Dashboard/Icons';
import Cards from './Dashboard/Apps/Cards';
import DraggableCards from './Dashboard/Apps/DraggableCards';
import Example from './Dashboard/Example';
import FullCalendar from './Dashboard/Apps/FullCalendar';
import ChartjsCharts from './Dashboard/Charts/ChartjsCharts';
import Apexlinecharts from './Dashboard/Charts/ApexCharts/Apexlinecharts';
import Echarts from './Dashboard/Charts/Echarts';
import Signin from './Custom Page/Signin';
import Signup from './Custom Page/Signup';
import Forgot from './Custom Page/Forgot';
import Reset from './Custom Page/Reset';
import Lockscreen from './Custom Page/Lockscreen';
import UnderMaintenance from './Custom Page/UnderMaintenance';
import Error500 from './Custom Page/Error500';
import Error501 from './Custom Page/Error501';
import Error404 from './Custom Page/Error404';
import Profile from './Dashboard/Pages/Profile';
import Contacts from './Dashboard/Apps/Contacts';
import Notifications from './Dashboard/Apps/Notifications';
import Widgets from './Dashboard/Apps/Widgets';
import WidgetNotification from './Dashboard/Apps/WidgetNotification';
import Treeview from './Dashboard/Apps/Treeview';
import FileManager from './Dashboard/Apps/File-Manager/FileManager';
import FileManagerList from './Dashboard/Apps/File-Manager/FileManagerList';
import FileManagerDetails from './Dashboard/Apps/File-Manager/FileManagerDetails';
import Alerts from './Dashboard/Elements/Alerts';
import Avatars from './Dashboard/Elements/Avatars';
import Breadcrumb from './Dashboard/Elements/Breadcrumb';
import Buttons from './Dashboard/Elements/Buttons';
import Buttongroup from './Dashboard/Elements/Buttongroup';
import Badge from './Dashboard/Elements/Badge';
import Dropdowns from './Dashboard/Elements/Dropdowns';
import Listgroup from './Dashboard/Elements/Listgroup';
import LinksInteractions from './Dashboard/Elements/LinksInteractions';
import Navbar from './Dashboard/Elements/Navbar';
import Header from './Components/Header';


import Client from './Dashboard/Client';
import ClientDetails from './Dashboard/ClientDetails';
import Deposits from './Dashboard/Deposit';
import DepositWallet from './Dashboard/DepositWallet';
import ClientWithdraw from './Dashboard/ClientWithdraw';
import Setting from './Dashboard/Setting';
import Support from './Dashboard/Support';
import MasterWallet from './Dashboard/MasterWallet';
import LevelRewardSetting from './Dashboard/LevelIncome';
import ForexWebSocket from './Dashboard/Websocket';

function Layout() {

  return (
    <>

      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/clients" element={<Client />} />
        <Route path="/clientsDetails" element={<ClientDetails />} />
        <Route path="/Deposits" element={<Deposits />} />
        <Route path="/Deposit-wallets" element={<DepositWallet />} />
        <Route path="/Clinet-withdraw" element={<ClientWithdraw />} />
        <Route path="/setting" element={<Setting />} />
        <Route path="/support" element={<Support />} />
        <Route path="/master-wallet" element={<MasterWallet />} />
        <Route path="/LevelRewardSetting" element={<LevelRewardSetting />} />
        <Route path="/web-socket" element={<ForexWebSocket />} />



        <Route path='/Icons' element={<Icons />} />
        <Route path='/Cards' element={<Cards />} />
        <Route path='/DraggableCards' element={<DraggableCards />} />
        <Route path='/Example' element={<Example />} />
        <Route path='/FullCalendar' element={<FullCalendar />} />
        <Route path='/chartjs-charts' element={<ChartjsCharts />} />
        <Route path='/apex-line-charts' element={<Apexlinecharts />} />
        <Route path='/echarts' element={<Echarts />} />

        {/* Custom Pages */}
        <Route path='/Signin' element={<Signin />} />
        <Route path='/Signup' element={<Signup />} />
        <Route path='/Forgot' element={<Forgot />} />
        <Route path='/Reset' element={<Reset />} />
        <Route path='/lockscreen' element={<Lockscreen />} />
        <Route path='/UnderMaintenance' element={<UnderMaintenance />} />
        <Route path='/Error404' element={<Error404 />} />
        <Route path='/Error500' element={<Error500 />} />
        <Route path='/Error501' element={<Error501 />} />

        {/* Pages */}
        <Route path='/Profile' element={<Profile />} />
        <Route path='/Contacts' element={<Contacts />} />
        <Route path='/Notifications' element={<Notifications />} />
        <Route path='/Widgets' element={<Widgets />} />
        <Route path='/widget-notification' element={<WidgetNotification />} />
        <Route path='/treeview' element={<Treeview />} />

        {/* File Manager */}
        <Route path='/file-manager' element={<FileManager />} />
        <Route path='/file-manager-list' element={<FileManagerList />} />
        <Route path='/file-manager-details' element={<FileManagerDetails />} />

        {/* Elements */}
        <Route path='/Alerts' element={<Alerts />} />
        <Route path='/Avatars' element={<Avatars />} />
        <Route path='/Breadcrumb' element={<Breadcrumb />} />
        <Route path='/Buttons' element={<Buttons />} />
        <Route path='/Buttongroup' element={<Buttongroup />} />
        <Route path='/Badge' element={<Badge />} />
        <Route path='/Dropdowns' element={<Dropdowns />} />
        <Route path='/Listgroup' element={<Listgroup />} />
        <Route path='/links_interactions' element={<LinksInteractions />} />
        <Route path='/Navbar' element={<Navbar />} />

      </Routes>


    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}

export default App;





